const useComposable = (define, emits) => {
  const values = [];
  const methods = {
    switchMode: (mode) => {
      switch (mode) {
        case "all": {
          define.modelValue.push(...values.filter((value) => !define.modelValue.includes(value)));
          break;
        }
        case "cancel": {
          define.modelValue.splice(0, define.modelValue.length);
          break;
        }
        case "reverse": {
          const result = values.filter((value) => !define.modelValue.includes(value));
          define.modelValue.splice(0, define.modelValue.length);
          define.modelValue.push(...result);
          break;
        }
      }
    }
  };
  return { methods, values };
};

export { useComposable };
//# sourceMappingURL=composable.mjs.map
